import { useCallback } from "react";

import { CreateEntryInput } from "@/generated/graphql/graphql";
import { useGetGeolocation } from "@/hooks/useGetGeolocation";

type GetEntryInput = () => Promise<CreateEntryInput>;

export const useGetEntryInput = () => {
  const getGeolocation = useGetGeolocation();

  return useCallback<GetEntryInput>(async () => {
    const { latitude, longitude } = await getGeolocation();

    return {
      latitude,
      longitude,
    };
  }, [getGeolocation]);
};
